import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomerService } from '../../../../_services/customer.service';
import { DebtorService } from '../../../../_services/debtor.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { ExcelService } from '../../../../_helpers/index';
import { ICustomer, DebtorsPatchRequest } from '../../../../_models/customer.interface';
import { ParameterData } from '../../../../_helpers/index';
import { Router } from '@angular/router';
import { debtorTipo, debtorStatus, debtorPhonePrefix, DocumentService } from '../../../../_enums/debtordocumenttype';
import { DataService } from '../../../../_helpers/dataservice.service'
import { AuthService } from '../../../../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UserService } from '../../../../_services/user.service';
import { User } from '../../../../_models/user.interface';
import { AppConfig } from '../../../../_helpers/index';
import { ConfirmPasswordValidator } from '../../../confirm-password.validator';
import { ChangePassword, UserList } from '../../../../_models/index';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-old-user-list',
  templateUrl: './old-user-list.component.html',
  styleUrls: ['../../../../../assets/css/customer-list-table.css']
})

export class OldUserListComponent implements OnInit {
  isalertVisiable = false;
  userKcoreId: any;
  isRoleAdmiReader: any;
  public passwordForm: FormGroup;
  public customer_public_id: string;
  searchFilterForm: FormGroup;
  userDetailsForm: FormGroup;
  userEditDetailsForm: FormGroup;
  displayedColumns: string[] = ['name', 'email', 'phone', 'role', 'status', 'actions'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  public iCustomer: ICustomer;
  debtorsPatchRequest: DebtorsPatchRequest[] = [];
  ddlUserStatus: any[];
  ddlUserRoles: any[];
  pageSize: number;
  PageSizeOptions: number[];
  isLoading = true;
  public User_publicid: string;
  public User_Count: number;
  isUserCountVisiable = true;
  isadmin = false;
  inputPrefixPhone: any;
  ddldebtorPhonePrefix: any[];
  ddldebtorPhonePrefix1: any;
  inputPhoneNo: any;
  roleDictionary: any;
  tempRoleList: any;
  userList = [];
  status: any = "All";
  dataRoleAdminTreasury: UserList[];
  constructor
    (
      private customerService: CustomerService
      , private _fb: FormBuilder
      , private excelService: ExcelService
      , private parameterData: ParameterData
      , private router: Router
      , private debtorService: DebtorService
      , private ddldebtorTipo: debtorTipo
      , private _debtorStatus: debtorStatus
      //, private _userRoles: userRoles
      , private dataService: DataService
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private userService: UserService
      , private _debtorPhonePrefix: debtorPhonePrefix
      , private _fbpass: FormBuilder,
      private documentService: DocumentService
    ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.User_Count = AppConfig.settings.userSetting.userCount;
    this.spinnerService.show();
    this.ddlUserStatus = _debtorStatus.Status;
    //this.ddlUserRoles = _userRoles.userRoles;
    this.isadmin = false;
    this.userKcoreId = localStorage.getItem('userId');
    this.isalertVisiable = false;
  }//end cons

 async ngOnInit() {
    let country = localStorage.getItem("country")
    this.ddldebtorPhonePrefix1 = this.documentService.getPrefixByIsoAlpha2(country);
    console.log(this.ddldebtorPhonePrefix1)
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {

      let browserStorage = localStorage.getItem('isadmin');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.isadmin = false;
        this.router.navigate(['/home']);
      }
      else {
        this.isadmin = true;
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {
      this.isadmin = true;
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }


    this.searchFilterForm = this._fb.group({
      searchText: ['', Validators.required]
    });

    this.InitialSetup();
    await this.getUserRoleList();
    this.GetCustomerUserDetails();
    this.getRole();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.inputPrefixPhone = "+51";
  }

  InitialSetup() {

    this.userDetailsForm = this._fb.group({
      name: new FormControl("", Validators.required),
      email: new FormControl("", Validators.required),
      phone: new FormControl(""),
      role: new FormControl("USER"),
      status: new FormControl("ACTIVE"),
      customer: this._fb.group({
        public_id: new FormControl(this.customer_public_id)
      })

    });

    this.userEditDetailsForm = this._fb.group({
      id: new FormControl(""),
      name: new FormControl("", Validators.required),
      email: new FormControl("", Validators.required),
      phone: new FormControl(""),
      role: new FormControl(""),
      status: new FormControl("Activo"),
      public_id: new FormControl(""),

    });
    this.inputPrefixPhone = "";
    this.inputPhoneNo = "";

      this.passwordForm = this._fbpass.group({
          newPassword: new FormControl("", Validators.compose([
              Validators.required,
              // check whether the entered password has a number
              ConfirmPasswordValidator.patternValidator(/\d/, {
                  hasNumber: true
              }),
              // check whether the entered password has upper case letter
              ConfirmPasswordValidator.patternValidator(/[A-Z]/, {
                  hasCapitalCase: true
              }),
              // check whether the entered password has a lower case letter
              ConfirmPasswordValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
              // check whether the entered password has a special character
              ConfirmPasswordValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                  {
                      hasSpecialCharacters: true
                  }
              ),
              Validators.minLength(8)
          ])),
          confirmPassword: new FormControl("", Validators.compose([Validators.required]))
      },
          {
              validator: ConfirmPasswordValidator.passwordMatchValidator
          });
  }

  getRole(){
    this.userService.getUser(this.userKcoreId).subscribe((user: User) => {
      this.isRoleAdmiReader = user.role
      console.log(this.isRoleAdmiReader)
  })
}

  getElementPubliID(element: UserList){
    this.User_publicid = element.public_id;
  }

  onsubmitpass({ value }: { value: ChangePassword }) {
    if (value.newPassword != null && value.newPassword != undefined && value.newPassword != "") {
        this.userService.changepassword(this.User_publicid, value).pipe(
          finalize(() => {
            this.passwordForm.reset();
          })
        )
            .subscribe((result) => {
                this.isalertVisiable = true;
            }, error => {
                console.log('Failed while trying to update the user password details.' + error);
            });
    }
}

  GetCustomerUserDetails() {
    this.spinnerService.show();
    this.customerService.getCustomerUserList(this.customer_public_id).subscribe(data => {
      let resources = data;
      this.dataSource.data = resources;
      this.userList = resources;
      if (this.dataSource.data.length < this.User_Count) {
        this.isUserCountVisiable = true;
      }
      else {
        this.isUserCountVisiable = false;
      }
      this.spinnerService.hide();
    },
      error => {
        console.log('Failed while trying to the Customer User Details Result. ' + error);
      });
  }

  applyFilter() {
    this.filter();
  }


  editUserDetails(element) {
    this.spinnerService.show();
    this.InitialSetup();
    this.User_publicid = element.public_id;
    this.userService.getUser(this.User_publicid).subscribe((data: User) => {
      this.inputPrefixPhone = this.documentService.getCountryCode(data.phone);
      this.inputPhoneNo = this.documentService.getPhoneNumberOnly(data.phone);
      this.userEditDetailsForm = this._fb.group({
        id: new FormControl(data.id),
        name: new FormControl(data.name),
        email: new FormControl(data.email, Validators.required),
        phone: new FormControl(this.documentService.getPhoneNumberOnly(data.phone)),
        role: new FormControl(data.role),
        status: new FormControl(data.status),
        public_id: new FormControl(data.public_id),

      });
      this.spinnerService.hide();
    })
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
            return false;
        }
    }
    return true;

}
  
  onupdateUserDetailsForm({ value }: { value: User }) {
    if (!(this.inputPrefixPhone == undefined || this.inputPrefixPhone == null || this.inputPrefixPhone == "Seleccione")) {
      value.phone = this.inputPrefixPhone + this.inputPhoneNo;
    }
    
    this.userService.updateUser(this.User_publicid, value)
      .subscribe((result) => {
        this.GetCustomerUserDetails();
        this.InitialSetup();
      }, error => {
        console.log('Failed. while trying to save the User Details.' + error);
      });
  }


  onsubmitUserDetailsForm({ value }: { value: User }) {
    if (!(this.inputPrefixPhone == undefined || this.inputPrefixPhone == null || this.inputPrefixPhone == "Seleccione")) {
      value.phone = this.inputPrefixPhone + this.inputPhoneNo;
    }
   
    this.userService.createUser(value)
      .subscribe((result) => {
        this.GetCustomerUserDetails();
        this.InitialSetup();
      }, error => {
        console.log('Failed while trying to save the User Details.' + error);
      });
  }


  filterStatusDetails(status) {
    if(status == 'TODOS'){
      this.status = "All"
    } else {
      this.status = status;
    }
    this.filter();
  }

  filter() {
    var tempFilterData = this.userList;
    if (this.status != "All") {
      tempFilterData = tempFilterData.filter(data => data.status == this.status)
    }

    if (this.searchFilterForm.controls.searchText.value.length > 0) {
      var serachValue = this.searchFilterForm.controls.searchText.value.trim();
      tempFilterData = tempFilterData.filter(data => data.name.toLowerCase().includes(serachValue.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
    this.paginator.firstPage();
  }

  async getUserRoleList() {
    try {
      const data = await this.customerService.getUserRoleList(this.customer_public_id);
      this.tempRoleList = data;
      this.ddlUserRoles = this.tempRoleList.values.user.property_list.role.enum;
      this.roleDictionary = this.tempRoleList.values.user.property_list.role.dictionary;
    }
    catch (error) {
      console.log('Failed while trying to get the User Role List' + error)
    }
  }

  userRoleLabel(role) {
    let roleLable = this.roleDictionary.filter(item => item.value == role)
    return roleLable[0].label;
  }
}